const GetTypeInput = (unitId, unitType) => {
    var unitMeasure = {
        decimalSeparator: "",
        suffix: "",
        decimalPrecision: 0
    }

    if (unitType == "Natural Number") {
        unitMeasure.decimalSeparator = "";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 0;
    } else if (unitType == "%, no decimal") {
        unitMeasure.decimalSeparator = "";
        unitMeasure.suffix = "%";
        unitMeasure.decimalPrecision = 0;
    } else if (unitType == "%, one decimal place") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "%";
        unitMeasure.decimalPrecision = 1;
    } else if (unitType == "%, two decimal cases") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "%";
        unitMeasure.decimalPrecision = 2;
    } else if (unitType == "%, four decimal cases") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "%";
        unitMeasure.decimalPrecision = 4;
    } else if (unitType == "No decimal") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 0;
    } else if (unitType == "One decimal place") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 1;
         unitMeasure.inputType = "decimal";
    } else if (unitType == "Two decimal places") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 2;
         unitMeasure.inputType = "decimal";
    } else if (unitType == "Three decimal places") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 3;
         unitMeasure.inputType = "decimal";
    } else if (unitType == "Four decimal places") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 4;
        unitMeasure.inputType = "decimal";
    } else if (unitType == "Six decimal places") {
        unitMeasure.decimalSeparator = ".";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 6;
         unitMeasure.inputType = "decimal";
    } else if (unitType === "Selection from kpi") {
        unitMeasure.decimalSeparator = "";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 0;
        unitMeasure.inputType = "input";
    } else {
        unitMeasure.decimalSeparator = "";
        unitMeasure.suffix = "";
        unitMeasure.decimalPrecision = 0;
    }

    return unitMeasure;
}

export default GetTypeInput;
